import {
  withStyles,
  WithStyles,
  Theme,
  Typography,
  Grid
  // Grid,
} from '@material-ui/core'
import { FC, Fragment } from 'react'
import { withTranslation, WithTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { deleteShowing } from '../../../actions/showings'
import Container from '../../../components/Container'
import { selectApartmentById } from '../../../selectors/apartments'
import { selectContentIdFromPathname } from '../../../selectors/router'
import { selectShowingsInterfaceByApartmentId } from '../../../selectors/showings'
import { DeleteShowingArgs } from '../../../services/showings'
import i18n from '../../../translations/i18n'
import { MuiClasses } from '../../../types'
import { Apartment } from '../../../types/apartments'
import { Showing } from '../../../types/showings'
import { EmptyShowingsInterface, StateInterface } from '../../../types/states'
import { getFutureShowings } from '../../../utils/showings/filterAndSearch'
import Suggest from '../../Apartment/Stepper/Steps/Suggest'
import ShowingsList from './ShowingsList'

const styles = ({ breakpoints, palette }: Theme) => ({
  generalContainer: {
    display: 'flex',
    justifyContent: 'space-evenly'
  },
  container: {
    display: 'flex',
    flexDirection: 'column' as const,
    overflow: 'hidden',
    width: '400px',
    margin: 'auto',
    [breakpoints.only('xs')]: {
      width: '100%',
      maxWidth: '400px'
    }
  },
  applications: {
    paddingTop: '2rem'
  },
  subContainer: {
    position: 'relative' as const,
    paddingTop: '2rem',
    [breakpoints.down('md')]: {
      padding: '2rem'
    },
    [breakpoints.down('sm')]: {
      padding: '1.2rem 0.5rem 0.5rem 0.5rem'
    }
  },
  line: {
    margin: '0',
    padding: '0',
    width: '100%',
    borderBottom: '1px solid' + palette.grey[100]
  },
  containerOfShowings: {
    [breakpoints.only('xs')]: {
      marginRight: '16px',
      width: '100%'
    }
  },
  suggestContainer: {
    margin: '16px'
  }
})

interface StateProps {
  existingShowings: Showing[]
  isMobile?: boolean
  apartment?: Apartment
}

interface DispatchProps {
  dispatchDeleteShowing: (args: DeleteShowingArgs) => void
}

interface ShowingsOverviewProps extends WithTranslation {
  classes: MuiClasses
  t: i18n.TFunction
}

type ComponentProps = StateProps &
  DispatchProps &
  ShowingsOverviewProps &
  WithStyles

const ShowingsOverview: FC<ComponentProps> = ({
  existingShowings,
  apartment,
  classes,
  t,
  dispatchDeleteShowing
}) => {
  const existingShowingsProps = {
    showings: existingShowings,
    t,
    deleteShowing: dispatchDeleteShowing
  }

  return (
    <Fragment>
      <Grid container className={classes.generalContainer}>
        <Grid item className={classes.containerOfShowings}>
          <Container className={classes.container}>
            <Container className={classes.subContainer}>
              <Typography variant='h5' gutterBottom>
                {t('showings.agreedShowingTimes')}
              </Typography>
              <Typography variant='h6'>
                {apartment &&
                  apartment.information &&
                  `${apartment.information.address}, ${apartment.information.postalCode} ${apartment.information.postalArea} `}
              </Typography>
            </Container>
            <div className={classes.line} />
            <ShowingsList useCase='confirmed' {...existingShowingsProps} />
            <ShowingsList useCase='waiting' {...existingShowingsProps} />
          </Container>
        </Grid>
        <Grid item className={classes.suggestContainer}>
          <Suggest
            containerMaxWidth='450px'
            contentMaxWidth='450px'
            content={i18n.t('showings.hints.overviewHint')}
          />
        </Grid>
      </Grid>
    </Fragment>
  )
}

const mapStateToProps = (state: StateInterface) => {
  const apartmentId = selectContentIdFromPathname(state)

  const showingsInterface = apartmentId
    ? selectShowingsInterfaceByApartmentId(apartmentId)(state)
    : EmptyShowingsInterface

  return {
    existingShowings: getFutureShowings(showingsInterface.showings, 'reserve'),
    apartment: apartmentId ? selectApartmentById(apartmentId)(state) : undefined
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  dispatchDeleteShowing: (args: DeleteShowingArgs) =>
    dispatch(deleteShowing(args))
})

export default connect<
  StateProps,
  DispatchProps,
  ShowingsOverviewProps,
  StateInterface
>(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(withStyles(styles)(ShowingsOverview)))
